<template lang="pug">
div.pad5
  app-divider(label="Destinação e Uso do Imóvel")
  el-row.pad5
    p
      span.text {{montarDestinacaoDoImovel()}}
  el-row.pad5
    p
      span.label Possui Reserva Legal?
      span.text &nbsp {{getPossuiReservaLegal(destinacaoUsoImovel.possuiReservaLegal)}}
    p(v-if="destinacaoUsoImovel.possuiReservaLegal === 'SIM'")
      span.label Área:
      span.text &nbsp {{filterNull(destinacaoUsoImovel.areaReservaLegal)}}
    p(v-if="destinacaoUsoImovel.possuiReservaLegal === 'SIM'")
      span.label Percentual Utilizado:
      span.text &nbsp {{filterNull(destinacaoUsoImovel.percentualAreaReservalegal)}}
    p
      span.label Possui comprovante de produtividade?
      span.text &nbsp {{getPossuiComprovante(destinacaoUsoImovel.produtividade.possuiComprovante)}}
    p(v-if="destinacaoUsoImovel.produtividade.possuiComprovante")
      span.label Tipo:
      span.text &nbsp {{getTipo(destinacaoUsoImovel.produtividade.tipo)}}
    p(v-if="destinacaoUsoImovel.produtividade.possuiComprovante && destinacaoUsoImovel.produtividade.tipo !== 'OUTROS'")
      span.label {{getLabel(destinacaoUsoImovel.produtividade.tipo)}}
      span.text &nbsp {{getNumero(destinacaoUsoImovel.produtividade)}}
    app-resumo-documentos(v-if="destinacaoUsoImovel.produtividade.possuiComprovante" :documentos="destinacaoUsoImovel.produtividade.documentos")
  el-row.pad5(v-if="temAtividade")
    //- CULTURAS PERMANENTES
    app-collapse(
      v-if="destinacaoUsoImovel.culturasPermanentes.length"
      :atividades="destinacaoUsoImovel.culturasPermanentes"
      titulo="Culturas Permanentes"
      tipoAtividade="CULTURA_PERMANENTE"
    )
    //- CULTURAS TEMPORÁRIAS
    app-collapse(
      v-if="destinacaoUsoImovel.culturasTemporarias.length"
      :atividades="destinacaoUsoImovel.culturasTemporarias"
      titulo="Culturas Temporarias"
      tipoAtividade="CULTURA_TEMPORARIA"
    )
    //- SEMOVENTES
    app-collapse(
      v-if="destinacaoUsoImovel.semoventes.length"
      :atividades="destinacaoUsoImovel.semoventes"
      titulo="Semoventes"
      tipoAtividade="SEMOVENTES"
    )
    //- EDIFICAÇÕES
    app-collapse(
      v-if="destinacaoUsoImovel.edificacoes.length"
      :atividades="destinacaoUsoImovel.edificacoes"
      titulo="Edificações"
      tipoAtividade="EDIFICACOES"
    )
    //- OUTRAS ATIVIDADES
    app-collapse(
      v-if="destinacaoUsoImovel.outrasAtividades.length"
      :atividades="destinacaoUsoImovel.outrasAtividades"
      titulo="Outras Atividades"
      tipoAtividade="OUTRAS_ATIVIDADES"
    )
</template>
<script>
import AppResumoDocumentos from './AppResumoDocumentos'
import AppCollapse from './AppCollapse'
import AppDivider from '@/components/AppDivider'

export default {
  components: {
    AppResumoDocumentos,
    AppCollapse,
    AppDivider
  },
  props: {
    destinacaoUsoImovel: {
      Type: Object,
      required: true
    }
  },
  computed: {
    temAtividade () {
      return (
        this.destinacaoUsoImovel.outrasAtividades.length || this.destinacaoUsoImovel.semoventes.length ||
        this.destinacaoUsoImovel.edificacoes.length || this.destinacaoUsoImovel.culturasTemporarias.length ||
        this.destinacaoUsoImovel.culturasPermanentes.length
      )
    }
  },
  methods: {
    filterNull (atributo) {
      return atributo !== null ? atributo : '-'
    },
    montarDestinacaoDoImovel () {
      const usoImovel = this.destinacaoUsoImovel

      // Mapear os campos com seus respectivos rótulos
      const camposMapeados = {
        agricultura: 'Agricultura',
        educacao: 'Educação',
        industria: 'Indústria',
        manejoFloresta: 'Manejo Florestal',
        mineracao: 'Mineração',
        outro: `Outro (${usoImovel.descricaoOutro})`,
        pecuaria: 'Pecuária',
        pesquisa: 'Pesquisa',
        recreacao: 'Recreação',
        servidaoAmbiental: 'Servidão Ambiental',
        sistemasAgroflorestais: 'Sistemas Agroflorestais',
        silvicultura: 'Silvicultura',
        assistencialHospitalar: 'Assistência Hospitalar'
      }

      // Filtrar as propriedades que estão `true`
      const descricaoDestinacaoUsoImovel = Object.keys(camposMapeados)
        .filter(campo => usoImovel[campo])
        .map(campo => camposMapeados[campo])

      // Juntar com vírgulas e adicionar o ponto final
      return descricaoDestinacaoUsoImovel.join(', ') + '.'
    },

    getPossuiReservaLegal (possuiReservaLegal) {
      switch (possuiReservaLegal) {
        case 'SIM':
          return 'Sim'
        case 'NAO_SABE':
          return 'Não sabe'
        case 'NAO':
          return 'Não'
      }
    },

    getPossuiComprovante (possuiComprovanteProdutividade) {
      if (possuiComprovanteProdutividade) {
        return 'Sim'
      }
      return 'Não'
    },

    getTipo (tipo) {
      switch (tipo) {
        case 'DAP':
          return 'Declaração de Aptidão ao PRONAF – DAP'
        case 'DRP':
          return 'Diagnóstico Rural Participativo – DRP'
        default:
          return 'Outros'
      }
    },

    getLabel (tipo) {
      return `Número do ${tipo}`
    },

    getNumero (produtividade) {
      if (produtividade.tipo === 'DAP') {
        return produtividade.dap
      }

      return produtividade.drp
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
  color: #606266;
}

.pad5 {
  padding: 25px 10px;
}

.text {
  color: #696580;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoDestinacaoUsoImovel.vue